import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { BrowserRouter } from 'react-router-dom';

import App from '$components/App';
import apiClient from '$utils/apiClient';
import getInstitutionNameForSentry from '$utils/getInstitutionNameForSentry';
import addAxiosInterceptors from '$utils/addAxiosInterceptors';

import configureStore from './store';

// sentry configuration
const institution = getInstitutionNameForSentry();
const { SENTRY_DSN } = process.env;
if (SENTRY_DSN && institution) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: institution,
  });
}

const store = configureStore();

addAxiosInterceptors(apiClient);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
